export enum CardTypes {
 SET_CARD_DATA = 'SET_CARD_DATA',
}

export interface PortfolioCard {
 id: number;
 profileId: string;
 userId: number;
 templateId: number;
 templateSubId: number;
 cardImage: string;
 dynamicUrl: string | null;
 qrcode: string;
 qrcodeImage: string;
 createdDate: null;
 bussinesName: string;
 email: string;
 number: string;
 lastName: string;
 isPublished: string;
 backCardImage: null;
 isDefault: string;
 companyName: string;
 postDestination: null;
 isExistingCard: string;
 video: null;
 isLibrary: string;
 isDeleted: string;
 tempCard: number;
 details: string;
 videoType: string;
 isCustom: string;
 adminTemplate: null;
 isEnterpriseCard: string;
 enterpriseId: null;
 enterpriseUsersId: null;
 enterpriseTemplateId: null;
 cardOrigin: null;
 jobTitle: string | null;
 license: string | null;
 fax: string | null;
 tollFree: string | null;
 direct: string | null;
 mobile: string| null;
 website: string | null;
}
